export default __webpack_public_path__ + "static/media/stopspillet.26ac3ed2.svg";